<div class="flex items-center w-full pr-4 pl-6 gap-4">
    <!-- Logo -->
    <div class="flex items-center justify-center h-20">
        <img
            class="w-8"
            src="assets/images/logo/logo.svg"
            alt="Logo image">
        
    </div>

    @if (isClassyLayout) {
        <!-- Components -->
        <div class="flex items-end text-xl font-bold text-primary">
            Zeitune <span class="ml-1 text-secondary text-xs"></span>
        </div>
    }
</div>
